/**
 * Authenticated fetch wrapper.
 * Adds the Bearer token from localStorage to all requests.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function apiFetch(path, options = {}) {
    const token = localStorage.getItem("session_token");
    const headers = { ...options.headers };
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    const url = path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
    return fetch(url, { ...options, headers });
}
